import * as fromDatatype from "../../../../models/datatype-library";

export class RecurringGenericDocSearchCriteriaDtoModel {
    guids?: any [];
    date_txn_to?: fromDatatype.TimestampTzDatatypeInterface;
    date_txn_from?: fromDatatype.TimestampTzDatatypeInterface;
    created_date_to?: fromDatatype.TimestampTzDatatypeInterface;
    created_date_from?: fromDatatype.TimestampTzDatatypeInterface; 
    updated_date_to?: fromDatatype.TimestampTzDatatypeInterface;
    updated_date_from?: fromDatatype.TimestampTzDatatypeInterface; 
    guid_branchs?: any [];
    store_guids?: any [];
    sales_entity_hdr_guids?: any [];
    doc_entity_hdr_guids?: any [];
    server_doc_locations?: any [];
    member_guids?: any [];
    processes?: any [];
    posting_statuses?: any [];
    contact_hdr_guids?: any [];
    hdr_del_region_hdr_guids?: any [];
    hdr_track_delivery_guids?: any [];
    hdr_track_production_guids?: any [];
    limit?: number;
  }
  